import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import API from '../../services/api';

const FEATURES = [
  { icon: '🎧', title: '24/7 Live Support', desc: 'Real agents ready to help you anytime, day or night.' },
  { icon: '🎮', title: 'Top Fantasy Games', desc: 'Access exclusive titles curated for serious players.' },
  { icon: '🎁', title: 'Exclusive Offers', desc: 'VIP deals, bonuses and rewards just for Blixo members.' },
  { icon: '🔒', title: 'Secure & Private', desc: '256-bit encryption keeps your data safe always.' },
];

const STATS = [
  { value: '100K+', label: 'Active Players' },
  { value: '50+', label: 'Games' },
  { value: '24/7', label: 'Support' },
  { value: '99.9%', label: 'Uptime' },
];

const STATUS_LABEL = { live: '🟢 Live', coming_soon: '🟡 Soon', maintenance: '🔴 Down' };

export default function Home() {
  const navigate = useNavigate();
  const [games, setGames] = useState([]);
  const [offers, setOffers] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    API.get('/games').then(({ data }) => setGames((Array.isArray(data) ? data : data.games || []).slice(0, 8))).catch(() => {});
    API.get('/offers').then(({ data }) => setOffers((Array.isArray(data) ? data : data.offers || []).slice(0, 4))).catch(() => {});
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#080c14', fontFamily: "'Exo 2',sans-serif", color: '#e2e8f0', overflowX: 'hidden' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@600;700&family=Exo+2:wght@400;600;700;900&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        html { scroll-behavior: smooth; }
        @keyframes float { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-14px)} }
        @keyframes pulse { 0%,100%{opacity:0.4} 50%{opacity:1} }
        @keyframes glow { 0%,100%{box-shadow:0 0 20px rgba(0,200,255,0.15)} 50%{box-shadow:0 0 50px rgba(0,200,255,0.4)} }
        @keyframes slideUp { from{opacity:0;transform:translateY(28px)} to{opacity:1;transform:translateY(0)} }
        @keyframes rotate { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }
        .blixo-bg-grid{position:fixed;inset:0;background-image:linear-gradient(rgba(0,200,255,0.03) 1px,transparent 1px),linear-gradient(90deg,rgba(0,200,255,0.03) 1px,transparent 1px);background-size:50px 50px;pointer-events:none;z-index:0}
        .blixo-glow1{position:fixed;top:-20%;left:-10%;width:60vw;height:60vw;background:radial-gradient(circle,rgba(0,200,255,0.06) 0%,transparent 70%);pointer-events:none;z-index:0}
        .blixo-glow2{position:fixed;bottom:-20%;right:-10%;width:50vw;height:50vw;background:radial-gradient(circle,rgba(0,212,255,0.05) 0%,transparent 70%);pointer-events:none;z-index:0}
        .b-nav{position:fixed;top:0;left:0;right:0;z-index:100;transition:all .3s}
        .b-nav-inner{max-width:1200px;margin:0 auto;padding:0 20px;height:64px;display:flex;align-items:center;gap:20px}
        .b-logo{display:flex;align-items:center;gap:8px;text-decoration:none;flex-shrink:0}
        .b-logo-text{font-family:'Rajdhani',sans-serif;font-size:20px;font-weight:700;color:#00C8FF;letter-spacing:5px}
        .b-nav-links{display:flex;gap:22px;flex:1;justify-content:center}
        .b-nav-link{color:rgba(255,255,255,0.5);text-decoration:none;font-size:13px;font-weight:600;letter-spacing:1px;transition:color .2s}
        .b-nav-link:hover{color:#00C8FF}
        .b-nav-actions{display:flex;gap:10px;align-items:center}
        .b-btn-login{color:rgba(255,255,255,0.6);text-decoration:none;font-size:13px;font-weight:700}
        .b-btn-signup{background:#00C8FF;color:#080c14;padding:8px 16px;border-radius:9px;text-decoration:none;font-size:12px;font-weight:900;letter-spacing:1px}
        .b-hamburger{display:none;background:none;border:1px solid rgba(0,200,255,0.25);color:#00C8FF;font-size:18px;cursor:pointer;padding:6px 10px;border-radius:8px;margin-left:auto}
        .b-mobile-menu{display:none;position:fixed;top:64px;left:0;right:0;background:rgba(8,12,20,.98);backdrop-filter:blur(12px);border-bottom:1px solid rgba(0,200,255,.1);padding:16px 20px;flex-direction:column;gap:4px;z-index:99}
        .b-mobile-menu.open{display:flex}
        .b-mobile-link{color:rgba(255,255,255,.6);text-decoration:none;font-size:15px;font-weight:600;padding:12px 0;border-bottom:1px solid rgba(255,255,255,.05);display:block}
        .b-mobile-cta{margin-top:8px;background:#00C8FF;color:#080c14;text-align:center;border-radius:10px;padding:13px;font-weight:900;text-decoration:none;display:block;font-size:14px}
        .b-hero{min-height:100vh;display:flex;align-items:center;padding:90px 20px 60px;max-width:1200px;margin:0 auto;gap:48px;position:relative;z-index:1}
        .b-hero-content{flex:1;animation:slideUp .8s ease both}
        .b-badge{display:inline-flex;align-items:center;gap:8px;background:rgba(0,200,255,.08);border:1px solid rgba(0,200,255,.2);border-radius:50px;padding:6px 14px;font-size:10px;font-weight:700;letter-spacing:2px;color:#00C8FF;margin-bottom:22px}
        .b-badge-dot{width:6px;height:6px;border-radius:50%;background:#00C8FF;animation:pulse 2s infinite;flex-shrink:0}
        .b-h1{font-family:'Rajdhani',sans-serif;line-height:1;margin-bottom:18px}
        .b-h1-l1{font-size:clamp(42px,8vw,88px);font-weight:700;color:#e2e8f0;display:block}
        .b-h1-l2{font-size:clamp(42px,8vw,88px);font-weight:700;color:#00C8FF;display:block}
        .b-h1-l3{font-size:clamp(28px,5vw,62px);font-weight:600;color:rgba(255,255,255,.3);display:block}
        .b-sub{font-size:15px;color:rgba(255,255,255,.4);line-height:1.7;max-width:480px;margin-bottom:28px}
        .b-ctas{display:flex;gap:12px;align-items:center;flex-wrap:wrap;margin-bottom:36px}
        .b-cta-main{background:#00C8FF;border:none;border-radius:12px;padding:14px 26px;color:#080c14;font-size:14px;font-weight:900;letter-spacing:2px;cursor:pointer;font-family:'Rajdhani',sans-serif;transition:all .2s;white-space:nowrap}
        .b-cta-main:hover{background:#00d4a0;transform:translateY(-2px);box-shadow:0 8px 28px rgba(0,200,255,.3)}
        .b-cta-sec{color:rgba(255,255,255,.4);text-decoration:none;font-size:14px;font-weight:600}
        .b-stats{display:flex;gap:24px;flex-wrap:wrap}
        .b-stat{display:flex;flex-direction:column;gap:2px}
        .b-stat-val{font-family:'Rajdhani',sans-serif;font-size:22px;font-weight:700;color:#00C8FF}
        .b-stat-lbl{font-size:10px;color:rgba(255,255,255,.3);letter-spacing:1px}
        .b-visual{flex:0 0 320px;display:flex;align-items:center;justify-content:center}
        .b-orb{width:320px;height:320px;position:relative;display:flex;align-items:center;justify-content:center;animation:float 4s ease-in-out infinite}
        .b-orb-inner{width:160px;height:160px;border-radius:50%;background:radial-gradient(circle,rgba(0,200,255,.18),rgba(0,200,255,.02));border:2px solid rgba(0,200,255,.3);display:flex;align-items:center;justify-content:center;font-size:66px;animation:glow 3s infinite}
        .b-orb-r1{position:absolute;width:280px;height:280px;border-radius:50%;border:1px solid rgba(0,200,255,.1);animation:rotate 8s linear infinite}
        .b-orb-r2{position:absolute;width:320px;height:320px;border-radius:50%;border:1px dashed rgba(0,200,255,.05);animation:rotate 14s linear infinite reverse}
        .b-section{padding:64px 20px;position:relative;z-index:1}
        .b-sec-inner{max-width:1200px;margin:0 auto}
        .b-sec-head{text-align:center;margin-bottom:40px}
        .b-sec-tag{display:inline-block;color:rgba(0,200,255,.7);font-size:10px;font-weight:900;letter-spacing:4px;margin-bottom:8px}
        .b-sec-title{font-family:'Rajdhani',sans-serif;font-size:clamp(24px,4vw,42px);font-weight:700;color:#e2e8f0;margin-bottom:8px}
        .b-sec-sub{color:rgba(255,255,255,.3);font-size:14px}
        .b-feat-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(210px,1fr));gap:16px}
        .b-feat-card{background:rgba(0,200,255,.03);border:1px solid rgba(0,200,255,.08);border-radius:16px;padding:24px;transition:all .25s}
        .b-feat-card:hover{background:rgba(0,200,255,.07);border-color:rgba(0,200,255,.25)}
        .b-feat-icon{font-size:32px;margin-bottom:12px}
        .b-feat-title{font-size:16px;font-weight:700;color:#e2e8f0;margin-bottom:6px;font-family:'Rajdhani',sans-serif}
        .b-feat-desc{color:rgba(255,255,255,.35);font-size:13px;line-height:1.6}
        .b-games-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:16px}
        .b-game-card{background:#0d1420;border-radius:16px;border:1px solid rgba(0,200,255,.08);overflow:hidden;position:relative;transition:all .25s}
        .b-game-card:hover{transform:translateY(-5px);border-color:rgba(0,200,255,.3)}
        .b-game-img{width:100%;height:150px;object-fit:cover;display:block}
        .b-game-ph{width:100%;height:110px;background:rgba(0,200,255,.04);display:flex;align-items:center;justify-content:center;font-size:40px}
        .b-feat-badge{position:absolute;top:9px;left:9px;background:rgba(0,180,255,.15);border:1px solid rgba(0,180,255,.4);color:#00C8FF;border-radius:5px;padding:2px 7px;font-size:9px;font-weight:700}
        .b-game-body{padding:13px}
        .b-game-top{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:6px;gap:5px}
        .b-game-name{font-size:14px;font-weight:700;color:#e2e8f0;flex:1}
        .b-genre{background:rgba(0,212,255,.1);border:1px solid rgba(0,212,255,.2);color:#00d4ff;border-radius:5px;padding:2px 6px;font-size:9px;flex-shrink:0}
        .b-game-desc{color:rgba(255,255,255,.3);font-size:11px;line-height:1.5;margin-bottom:9px}
        .b-play-btn{width:100%;background:#00C8FF;border:none;border-radius:9px;padding:9px;color:#080c14;font-size:12px;font-weight:900;letter-spacing:1px;cursor:pointer;font-family:'Rajdhani',sans-serif;transition:background .2s}
        .b-play-btn:hover{background:#00d4a0}
        .b-offers-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(260px,1fr));gap:16px}
        .b-offer-card{background:#0d1420;border-radius:16px;border:1px solid rgba(0,200,255,.08);overflow:hidden;position:relative;transition:all .25s}
        .b-offer-card:hover{transform:translateY(-5px);border-color:rgba(0,200,255,.3)}
        .b-offer-img{width:100%;height:160px;object-fit:cover;display:block}
        .b-offer-ph{width:100%;height:115px;background:rgba(0,200,255,.04);display:flex;align-items:center;justify-content:center;font-size:42px}
        .b-offer-badge{position:absolute;top:11px;left:11px;background:linear-gradient(90deg,#00C8FF,#00d4ff);color:#080c14;font-size:9px;font-weight:900;letter-spacing:2px;border-radius:5px;padding:3px 9px}
        .b-offer-body{padding:15px}
        .b-offer-name{font-size:16px;font-weight:700;color:#e2e8f0;margin-bottom:4px;font-family:'Rajdhani',sans-serif}
        .b-offer-sub{color:#00C8FF;font-size:12px;margin-bottom:7px}
        .b-offer-desc{color:rgba(255,255,255,.3);font-size:12px;line-height:1.5;margin-bottom:12px}
        .b-claim-btn{width:100%;background:linear-gradient(90deg,#00C8FF,#00d4ff);border:none;border-radius:9px;padding:10px;color:#080c14;font-size:12px;font-weight:900;letter-spacing:1px;cursor:pointer;font-family:'Rajdhani',sans-serif;transition:opacity .2s}
        .b-claim-btn:hover{opacity:.85}
        .b-sec-cta{text-align:center;margin-top:32px}
        .b-view-all{background:transparent;border:1px solid rgba(0,200,255,.3);border-radius:11px;padding:11px 26px;color:#00C8FF;font-size:13px;font-weight:700;cursor:pointer;letter-spacing:1px;transition:all .2s;font-family:'Exo 2',sans-serif}
        .b-view-all:hover{background:rgba(0,200,255,.06)}
        .b-cta-banner{padding:64px 20px;background:linear-gradient(135deg,rgba(0,200,255,.05),rgba(0,212,255,.03));border-top:1px solid rgba(0,200,255,.08);border-bottom:1px solid rgba(0,200,255,.08);text-align:center;position:relative;z-index:1}
        .b-cta-title{font-family:'Rajdhani',sans-serif;font-size:clamp(28px,5vw,52px);font-weight:700;color:#e2e8f0;margin-bottom:12px}
        .b-cta-sub{color:rgba(255,255,255,.35);font-size:14px;margin-bottom:24px;line-height:1.6}
        .b-footer{padding:32px 20px;border-top:1px solid rgba(0,200,255,.06);position:relative;z-index:1}
        .b-footer-inner{max-width:1200px;margin:0 auto;display:flex;flex-direction:column;align-items:center;gap:16px}
        .b-footer-brand{display:flex;align-items:center;gap:8px}
        .b-footer-links{display:flex;gap:20px;flex-wrap:wrap;justify-content:center}
        .b-footer-link{color:rgba(255,255,255,.3);text-decoration:none;font-size:13px}
        .b-footer-link:hover{color:#00C8FF}
        .b-footer-copy{color:rgba(255,255,255,.15);font-size:12px}
        .b-empty{text-align:center;color:rgba(255,255,255,.25);padding:48px;font-size:14px}
        .b-apk-banner{position:relative;z-index:1;padding:0 20px 0;max-width:1200px;margin:0 auto 0}
        .b-apk-card{background:linear-gradient(135deg,rgba(0,200,255,.07) 0%,rgba(0,212,255,.04) 100%);border:1px solid rgba(0,200,255,.18);border-radius:20px;padding:28px 32px;display:flex;align-items:center;gap:24px;flex-wrap:wrap}
        .b-apk-icon{font-size:44px;flex-shrink:0}
        .b-apk-text{flex:1;min-width:180px}
        .b-apk-title{font-family:'Rajdhani',sans-serif;font-size:22px;font-weight:700;color:#e2e8f0;margin-bottom:4px}
        .b-apk-sub{color:rgba(255,255,255,.35);font-size:13px}
        .b-apk-btn{display:flex;align-items:center;gap:10px;background:#00C8FF;border:none;border-radius:12px;padding:13px 22px;color:#080c14;font-size:13px;font-weight:900;letter-spacing:1px;cursor:pointer;font-family:'Rajdhani',sans-serif;text-decoration:none;flex-shrink:0;transition:all .2s}
        .b-apk-btn:hover{background:#00d4a0;transform:translateY(-2px);box-shadow:0 8px 28px rgba(0,200,255,.25)}
        .b-apk-btn-icon{font-size:20px}
        .b-apk-badge{display:inline-flex;align-items:center;gap:5px;background:rgba(0,212,255,.08);border:1px solid rgba(0,212,255,.15);border-radius:6px;padding:3px 9px;font-size:10px;color:rgba(0,212,255,.7);margin-top:6px}
        @media(max-width:600px){
          .b-apk-card{flex-direction:column;align-items:flex-start;padding:22px 20px}
          .b-apk-btn{width:100%;justify-content:center}
        }

        @media(max-width:768px){
          .b-nav-links,.b-nav-actions{display:none}
          .b-hamburger{display:block}
          .b-hero{flex-direction:column;padding:84px 20px 48px;gap:32px;min-height:auto}
          .b-visual{display:none}
          .b-stats{gap:18px}
          .b-feat-grid{grid-template-columns:1fr 1fr}
          .b-games-grid{grid-template-columns:1fr 1fr}
          .b-offers-grid{grid-template-columns:1fr}
          .b-section{padding:48px 16px}
        }
        @media(max-width:480px){
          .b-feat-grid{grid-template-columns:1fr}
          .b-games-grid{grid-template-columns:1fr}
          .b-ctas{flex-direction:column;align-items:stretch}
          .b-cta-main{text-align:center}
          .b-cta-sec{text-align:center}
          .b-stats{gap:14px}
          .b-stat-val{font-size:18px}
        }
      `}</style>

      <div className="blixo-bg-grid" />
      <div className="blixo-glow1" />
      <div className="blixo-glow2" />

      {/* Navbar */}
      <nav className="b-nav" style={{ background: scrolled ? 'rgba(8,12,20,.96)' : 'transparent', backdropFilter: scrolled ? 'blur(12px)' : 'none', borderBottom: scrolled ? '1px solid rgba(0,200,255,.08)' : 'none' }}>
        <div className="b-nav-inner">
          <Link to="/" className="b-logo">
            <span className="b-logo-text">AIA74</span>
          </Link>
          <div className="b-nav-links">
            <a href="#games" className="b-nav-link">Games</a>
            <a href="#offers" className="b-nav-link">Offers</a>
            <Link to="/support" className="b-nav-link">Support</Link>
            <Link to="/privacy" className="b-nav-link">Privacy</Link>
          </div>
          <div className="b-nav-actions">
            <Link to="/login" className="b-btn-login">→ LOGIN</Link>
            <Link to="/register" className="b-btn-signup">JOIN FREE</Link>
          </div>
          <button className="b-hamburger" onClick={() => setMenuOpen(!menuOpen)}>☰</button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`b-mobile-menu${menuOpen ? ' open' : ''}`}>
        <a href="#games" className="b-mobile-link" onClick={() => setMenuOpen(false)}>🎮 Games</a>
        <a href="#offers" className="b-mobile-link" onClick={() => setMenuOpen(false)}>🎁 Offers</a>
        <Link to="/support" className="b-mobile-link" onClick={() => setMenuOpen(false)}>💬 Support</Link>
        <Link to="/privacy" className="b-mobile-link" onClick={() => setMenuOpen(false)}>🔒 Privacy</Link>
        <Link to="/login" className="b-mobile-link" onClick={() => setMenuOpen(false)} style={{ color: '#00C8FF' }}>→ Login</Link>
        <Link to="/register" className="b-mobile-cta" onClick={() => setMenuOpen(false)}>JOIN FREE — IT'S FREE</Link>
      </div>

      {/* Hero */}
      <section className="b-hero">
        <div className="b-hero-content">
          <div className="b-badge">
            <span className="b-badge-dot" />
            #1 FISH GAMING DESTINATION
          </div>
          <h1 className="b-h1">
            <span className="b-h1-l1">SHOOT. WIN.</span>
            <span className="b-h1-l2">REPEAT.</span>
            <span className="b-h1-l3">YOUR PLATFORM. YOUR REWARDS.</span>
          </h1>
          <p className="b-sub">Top fish games, exclusive VIP deals and live agent support — built for serious players only.</p>
          <div className="b-ctas">
            <button className="b-cta-main" onClick={() => navigate('/register')}>▶ PLAY NOW — IT'S FREE</button>
            <a href="#games" className="b-cta-sec">Browse Games →</a>
          </div>
          <div className="b-stats">
            {STATS.map(s => (
              <div key={s.label} className="b-stat">
                <span className="b-stat-val">{s.value}</span>
                <span className="b-stat-lbl">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="b-visual">
          <div className="b-orb">
            <div className="b-orb-inner"><img src="/logo.jpg" alt="" style={{ width: "180px", height: "180px", objectFit: "contain", borderRadius: "50%" }} /></div>
            <div className="b-orb-r1" />
            <div className="b-orb-r2" />
          </div>
        </div>
      </section>

      {/* App Download Banner
      <div style={{ position: 'relative', zIndex: 1, padding: '0 20px', maxWidth: '1200px', margin: '0 auto' }}>
        <div className="b-apk-card">
          <div className="b-apk-icon">📱</div>
          <div className="b-apk-text">
            <div className="b-apk-title">Play on the Go — Download Our Android App</div>
            <div className="b-apk-sub">Get instant support notifications, browse games and chat with agents from your phone.</div>
            <div className="b-apk-badge">✓ Free · Lightning Fast • Seamless Gameplay</div>
          </div>
          <a
            className="b-apk-btn"
            href="https://expo.dev/artifacts/eas/9f8W8SqE8CV9U59haTTV23.apk"
            download="AIA74.apk"
            target="_blank"
            rel="noreferrer"
          >
            <span className="b-apk-btn-icon">⬇</span>
            DOWNLOAD APK
          </a>
        </div>
      </div> */}

      {/* Features */}
      <section className="b-section">
        <div className="b-sec-inner">
          <div className="b-sec-head">
            <div className="b-sec-tag">WHY AIA74</div>
            <h2 className="b-sec-title">Everything a gamer needs</h2>
          </div>
          <div className="b-feat-grid">
            {FEATURES.map(f => (
              <div key={f.title} className="b-feat-card">
                <div className="b-feat-icon">{f.icon}</div>
                <h3 className="b-feat-title">{f.title}</h3>
                <p className="b-feat-desc">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Games */}
      <section id="games" className="b-section">
        <div className="b-sec-inner">
          <div className="b-sec-head">
            <div className="b-sec-tag">GAME CATALOGUE</div>
            <h2 className="b-sec-title">Featured Games</h2>
            <p className="b-sec-sub">Premium titles handpicked for the ultimate experience</p>
          </div>
          {games.length === 0 ? (
            <div className="b-empty">🎮 Games loading... Check back soon!</div>
          ) : (
            <div className="b-games-grid">
              {games.map(game => (
                <div key={game._id} className="b-game-card">
                  {game.imageUrl ? <img src={game.imageUrl} alt={game.name} className="b-game-img" /> : <div className="b-game-ph">🎮</div>}
                  {game.featured && <div className="b-feat-badge">⭐ Featured</div>}
                  <div className="b-game-body">
                    <div className="b-game-top">
                      <h3 className="b-game-name">{game.name}</h3>
                      <span className="b-genre">{game.genre}</span>
                    </div>
                    <p className="b-game-desc">{game.description ? game.description.slice(0, 55) + '…' : 'No description.'}</p>
                    <button className="b-play-btn" onClick={() => navigate('/login')}>▶ PLAY NOW</button>
                  </div>
                </div>
              ))}
            </div>
          )}
          <div className="b-sec-cta">
            <button className="b-view-all" onClick={() => navigate('/games')}>View All Games →</button>
          </div>
        </div>
      </section>

      {/* Offers */}
      <section id="offers" className="b-section" style={{ background: 'rgba(0,200,255,.015)' }}>
        <div className="b-sec-inner">
          <div className="b-sec-head">
            <div className="b-sec-tag">EXCLUSIVE DEALS</div>
            <h2 className="b-sec-title">Hot Offers</h2>
            <p className="b-sec-sub">Limited time deals for Blixo members only</p>
          </div>
          {offers.length === 0 ? (
            <div className="b-empty">🎁 No offers right now — check back soon!</div>
          ) : (
            <div className="b-offers-grid">
              {offers.map(offer => (
                <div key={offer._id} className="b-offer-card">
                  {offer.imageUrl ? <img src={offer.imageUrl} alt={offer.name} className="b-offer-img" /> : <div className="b-offer-ph">🎁</div>}
                  <div className="b-offer-badge">EXCLUSIVE</div>
                  <div className="b-offer-body">
                    <h3 className="b-offer-name">{offer.name}</h3>
                    {offer.subtitle && <p className="b-offer-sub">{offer.subtitle}</p>}
                    <p className="b-offer-desc">{offer.description ? offer.description.slice(0, 80) + '…' : ''}</p>
                    <button className="b-claim-btn" onClick={() => navigate('/login')}>🎁 CLAIM NOW</button>
                  </div>
                </div>
              ))}
            </div>
          )}
          <div className="b-sec-cta">
            <button className="b-view-all" onClick={() => navigate('/offers')}>View All Offers →</button>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="b-cta-banner">
        <h2 className="b-cta-title">Ready to play?</h2>
        <p className="b-cta-sub">Join thousands of players on Blixo today — it's completely free.</p>
        <button className="b-cta-main" onClick={() => navigate('/register')}>CREATE FREE ACCOUNT →</button>
      </section>

      {/* Footer */}
      <footer className="b-footer">
        <div className="b-footer-inner">
          <div className="b-footer-brand">
            <img src="/logo.jpg" alt="AIA74" style={{ height: '38px', width: 'auto', objectFit: 'contain' }} />
          </div>
          <div className="b-footer-links">
            <Link to="/games" className="b-footer-link">Games</Link>
            <Link to="/offers" className="b-footer-link">Offers</Link>
            <Link to="/support" className="b-footer-link">Support</Link>
            <Link to="/privacy" className="b-footer-link">Privacy</Link>
            <Link to="/login" className="b-footer-link">Login</Link>
            <a href="https://expo.dev/artifacts/eas/9f8W8SqE8CV9U59haTTV23.apk" className="b-footer-link" target="_blank" rel="noreferrer">📱 Android App</a>
          </div>
          <p className="b-footer-copy">© 2025 AIA74. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}